import { render } from "./AmazonAdsLogoIcon.vue?vue&type=template&id=bc44720a"
import script from "./AmazonAdsLogoIcon.vue?vue&type=script&lang=js"
export * from "./AmazonAdsLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__